/**
 * PaymentsCancelled.jsx — minimal "you cancelled the checkout" landing.
 * Stripe redirects here when the user closes the checkout tab.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Ban } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentsCancelled = () => {
  const navigate = useNavigate();
  return (
    <main className="min-h-[80vh] flex items-center justify-center px-4">
      <div
        className="max-w-md w-full rounded-2xl border bg-slate-900/80 backdrop-blur-xl border-slate-700 p-8 text-center shadow-2xl"
        data-testid="payments-cancelled-card"
      >
        <Ban className="w-12 h-12 text-slate-400 mx-auto mb-4" />
        <h1 className="text-xl font-bold text-white mb-2">Checkout cancelled</h1>
        <p className="text-sm text-slate-400 mb-6">
          No charges were made. You can try again whenever you're ready.
        </p>
        <Button
          onClick={() => navigate(-1)}
          className="bg-indigo-500 hover:bg-indigo-400 text-white rounded-full px-8"
        >
          Back
        </Button>
      </div>
    </main>
  );
};

export default PaymentsCancelled;
